export default __webpack_public_path__ + "static/media/intro-2.1b6d14cb.jpg";